export const legacyVariants = {
  // Display & Headlines
  displayAndHeadlineXtraLarge: [
    'font-nista-grotesk tracking-[-1px] text-[48px] leading-[56px] font-medium',
    'md:tracking-[-1.7px] md:text-[56px] md:leading-[64px]',
    'lg:tracking-[-1.9px] lg:text-[64px] lg:leading-[72px]'
  ],
  displayAndHeadlineLarge: [
    'font-nista-grotesk tracking-[-1px] text-[42px] leading-[48px] font-medium',
    'md:tracking-[-1.7px] md:text-[48px] md:leading-[56px]',
    'lg:tracking-[-1.9px] lg:text-[56px] lg:leading-[64px]'
  ],
  displayAndHeadlineMedium: [
    'font-nista-grotesk tracking-[-0.8px] text-[40px] leading-[48px] font-medium',
    'md:tracking-[-0.8px] md:text-[42px] md:leading-[48px]',
    'lg:tracking-[-1px] lg:text-[48px] lg:leading-[56px]'
  ],
  displayAndHeadlineSmall: [
    'font-nista-grotesk tracking-[-0.6px] text-[32px] leading-[40px] font-medium',
    'md:tracking-[-0.7px] md:text-[36px] md:leading-[44px]',
    'lg:tracking-[-0.8px] lg:text-[40px] lg:leading-[48px]'
  ],
  displayAndHeadlineXtraSmall: [
    'font-nista-grotesk tracking-[-0.5px] text-[26px] leading-[28px] font-medium',
    'md:tracking-[-0.6px] md:text-[28px] md:leading-[32px]',
    'lg:tracking-[-0.6px] lg:text-[32px] lg:leading-[36px]'
  ],
  displayAndHeadline2XtraSmallMedium: [
    'font-nista-grotesk tracking-[-0.4px] text-[20px] leading-[24px] font-medium',
    'md:tracking-[-0.4px] md:text-[20px] md:leading-[28px]',
    'lg:tracking-[-0.5px] lg:text-[24px] lg:leading-[32px]'
  ],
  // Section Headers
  sectionHeaderMedium: [
    'font-nista-grotesk tracking-[-0.6px] text-[32px] leading-[40px] font-medium',
    'md:tracking-[-0.7px] md:text-[36px] md:leading-[44px]',
    'lg:tracking-[-0.8px] lg:text-[40px] lg:leading-[48px]'
  ],
  // Subsection Headers
  subsectionHeaderMedium: [
    'font-nista-grotesk tracking-[-0.5px] text-[24px] leading-[28px] font-medium',
    'md:tracking-[-0.5px] md:text-[26px] md:leading-[32px]',
    'lg:tracking-[-0.6px] lg:text-[28px] lg:leading-[36px]'
  ],
  subsectionHeaderRegular: [
    'font-nista-grotesk tracking-[-0.5px] text-[24px] leading-[28px] font-normal',
    'md:tracking-[-0.5px] md:text-[26px] md:leading-[32px]',
    'lg:tracking-[-0.6px] lg:text-[28px] lg:leading-[36px]'
  ],
  subsectionHeaderDense: [
    'font-nista-grotesk tracking-[-0.5px] text-[24px] leading-[24px] font-medium',
    'md:tracking-[-0.5px] md:text-[26px] md:leading-[28px]',
    'lg:tracking-[-0.6px] lg:text-[28px] lg:leading-[32px]'
  ],
  subsectionHeaderSmallMedium: [
    'font-nista-grotesk tracking-[-0.4px] text-[20px] leading-[24px] font-medium',
    'md:tracking-[-0.4px] md:text-[22px] md:leading-[28px]',
    'lg:tracking-[-0.5px] lg:text-[24px] lg:leading-[32px]'
  ],
  // Subheaders
  subheaderLargeMedium: [
    'font-nista-grotesk tracking-[-0.4px] text-[20px] leading-[24px] font-medium',
    'md:tracking-[-0.4px] md:text-[22px] md:leading-[28px]',
    'lg:tracking-[-0.5px] lg:text-[24px] lg:leading-[32px]'
  ],
  subheaderMediumMedium: [
    'font-nista-grotesk tracking-[-0.4px] text-[18px] leading-[20px] font-medium',
    'md:tracking-[-0.4px] md:text-[20px] md:leading-[24px]',
    'lg:tracking-[-0.4px] lg:text-[22px] lg:leading-[28px]'
  ],
  subheaderSmallMedium: ['tracking-[-0.4px] text-[20px] leading-[24px] font-medium'],
  // Body text
  bodyLargeRegular: [
    'font-nista-grotesk tracking-[-0.4px] text-[18px] leading-[26px] font-normal',
    'md:tracking-[-0.4px] md:text-[18px] md:leading-[26px]',
    'lg:tracking-[-0.4px] lg:text-[18px] lg:leading-[26px]'
  ],
  bodyLargeMedium: [
    'font-nista-grotesk tracking-[-0.4px] text-[18px] leading-[26px] font-medium',
    'md:tracking-[-0.4px] md:text-[18px] md:leading-[26px]',
    'lg:tracking-[-0.4px] lg:text-[18px] lg:leading-[26px]'
  ],
  bodyMediumBaseRegular: [
    'font-nista-grotesk tracking-[-0.3px] text-[16px] leading-[24px] font-normal',
    'md:tracking-[-0.3px] md:text-[16px] md:leading-[24px]',
    'lg:tracking-[-0.3px] lg:text-[16px] lg:leading-[24px]'
  ],
  bodyMediumBaseMedium: [
    'font-nista-grotesk tracking-[-0.3px] text-[16px] leading-[24px] font-medium',
    'md:tracking-[-0.3px] md:text-[16px] md:leading-[24px]',
    'lg:tracking-[-0.3px] lg:text-[16px] lg:leading-[24px]'
  ],
  bodySmallRegular: [
    'font-nista-grotesk tracking-[-0.3px] text-[14px] leading-[20px] font-normal',
    'md:tracking-[-0.3px] md:text-[14px] md:leading-[20px]',
    'lg:tracking-[-0.3px] lg:text-[14px] lg:leading-[20px]'
  ],
  bodySmallMedium: [
    'font-nista-grotesk tracking-[-0.1px] text-[14px] leading-[20px] font-medium',
    'md:tracking-[-0.1px] md:text-[14px] md:leading-[20px]',
    'lg:tracking-[-0.1px] lg:text-[14px] lg:leading-[20px]'
  ],
  bodySmallMediumTabular: [
    'font-nista-grotesk tracking-[-0.3px] text-[14px] leading-[20px] font-medium tabular-nums',
    'md:tracking-[-0.3px] md:text-[14px] md:leading-[20px]',
    'lg:tracking-[-0.3px] lg:text-[14px] lg:leading-[20px]'
  ],
  bodyExtraSmallRegular: [
    'font-nista-grotesk tracking-[-0.4px] text-[12px] leading-[16px] font-normal',
    'md:tracking-[-0.4px] md:text-[12px] md:leading-[16px]',
    'lg:tracking-[-0.4px] lg:text-[12px] lg:leading-[16px]'
  ],
  bodyExtraSmallMedium: [
    'font-nista-grotesk tracking-[-0.4px] text-[12px] leading-[16px] font-normal',
    'md:tracking-[-0.4px] md:text-[12px] md:leading-[16px]',
    'lg:tracking-[-0.4px] lg:text-[12px] lg:leading-[16px]'
  ],
  // Intro Lead
  introLeadLargeRegular: [
    'font-nista-grotesk tracking-[-0.4px] text-[20px] leading-[20px] font-normal',
    'md:tracking-[-0.4px] md:text-[20px] md:leading-[24px]',
    'lg:tracking-[-0.4px] lg:text-[24px] lg:leading-[28px]'
  ],
  introLeadMediumRegular: [
    'font-nista-grotesk tracking-[-0.4px] text-[18px] leading-[26px] font-normal',
    'md:tracking-[-0.4px] md:text-[18px] md:leading-[26px]',
    'lg:tracking-[-0.4px] lg:text-[18px] lg:leading-[26px]'
  ],
  introLeadSmallRegular: [
    'font-nista-grotesk tracking-[-0.3px] text-[16px] leading-[24px] font-normal',
    'md:tracking-[-0.3px] md:text-[16px] md:leading-[24px]',
    'lg:tracking-[-0.3px] lg:text-[16px] lg:leading-[24px]'
  ],
  // Callouts
  calloutLargeMedium: [
    'font-nista-grotesk tracking-[-0.5px] text-[26px] leading-[32px] font-medium',
    'md:tracking-[-0.6px] md:text-[28px] md:leading-[36px]',
    'lg:tracking-[-0.6px] lg:text-[32px] lg:leading-[40px]'
  ],
  calloutMediumMedium: [
    'font-nista-grotesk tracking-[-0.5px] text-[24px] leading-[28px] font-medium',
    'md:tracking-[-0.5px] md:text-[26px] md:leading-[32px]',
    'lg:tracking-[-0.6px] lg:text-[28px] lg:leading-[36px]'
  ],
  calloutSmallMedium: [
    'font-nista-grotesk tracking-[-0.4px] text-[20px] leading-[24px] font-medium',
    'md:tracking-[-0.4px] md:text-[22px] md:leading-[28px]',
    'lg:tracking-[-0.5px] lg:text-[24px] lg:leading-[32px]'
  ],
  calloutExtraSmallMedium: [
    'font-nista-grotesk tracking-[-0.4px] text-[20px] leading-[24px] font-medium',
    'md:tracking-[-0.4px] md:text-[20px] md:leading-[24px]',
    'lg:tracking-[-0.4px] lg:text-[20px] lg:leading-[24px]'
  ],
  callout2XtraSmallMedium: [
    'font-nista-grotesk tracking-[-0.4px] text-[18px] leading-[22px] font-medium',
    'md:tracking-[-0.4px] md:text-[18px] md:leading-[22px]',
    'lg:tracking-[-0.4px] lg:text-[18px] lg:leading-[22px]'
  ],
  callout3XtraSmallMedium: [
    'font-nista-grotesk tracking-[-0.3px] text-[16px] leading-[20px] font-medium',
    'md:tracking-[-0.3px] md:text-[16px] md:leading-[20px]',
    'lg:tracking-[-0.3px] lg:text-[16px] lg:leading-[20px]'
  ],
  // Overlines
  overlineLargeRegular: [
    'font-nista-grotesk tracking-[-0.3px] text-[14px] leading-[20px] font-normal',
    'md:tracking-[-0.3px] md:text-[14px] md:leading-[20px]',
    'lg:tracking-[-0.3px] lg:text-[14px] lg:leading-[20px]'
  ],
  overlineLargeDenseRegular: [
    'font-nista-grotesk tracking-[-0.3px] text-[14px] leading-[18px] font-normal',
    'md:tracking-[-0.3px] md:text-[14px] md:leading-[18px]',
    'lg:tracking-[-0.3px] lg:text-[14px] lg:leading-[18px]'
  ],
  overlineMediumRegular: [
    'font-nista-grotesk tracking-[-0.2px] text-[12px] leading-[16px] font-normal',
    'md:tracking-[-0.2px] md:text-[12px] md:leading-[16px]',
    'lg:tracking-[-0.2px] lg:text-[12px] lg:leading-[16px]'
  ],
  overlineSmallRegular: [
    'font-nista-grotesk tracking-[-0.2px] text-[11px] leading-[12px] font-normal',
    'md:tracking-[-0.2px] md:text-[11px] md:leading-[12px]',
    'lg:tracking-[-0.2px] lg:text-[11px] lg:leading-[12px]'
  ],
  // Labels
  labelLargeRegular: [
    'font-nista-grotesk tracking-[-0.3px] text-[16px] leading-[20px] font-normal',
    'md:tracking-[-0.3px] md:text-[16px] md:leading-[20px]',
    'lg:tracking-[-0.3px] lg:text-[16px] lg:leading-[20px]'
  ],
  labelLargeMedium: [
    'font-nista-grotesk tracking-[-0.3px] text-[16px] leading-[20px] font-medium',
    'md:tracking-[-0.3px] md:text-[16px] md:leading-[20px]',
    'lg:tracking-[-0.3px] lg:text-[16px] lg:leading-[20px]'
  ],
  labelMediumRegular: [
    'font-nista-grotesk tracking-[-0.3px] text-[14px] leading-[20px] font-normal',
    'md:tracking-[-0.3px] md:text-[14px] md:leading-[20px]',
    'lg:tracking-[-0.3px] lg:text-[14px] lg:leading-[20px]'
  ],
  labelMediumMedium: [
    'font-nista-grotesk tracking-[-0.3px] text-[14px] leading-[20px] font-medium',
    'md:tracking-[-0.3px] md:text-[14px] md:leading-[20px]',
    'lg:tracking-[-0.3px] lg:text-[14px] lg:leading-[20px]'
  ],
  labelMediumRegularDense: [
    'font-nista-grotesk tracking-[-0.3px] text-[14px] leading-[16px] font-normal',
    'md:tracking-[-0.3px] md:text-[14px] md:leading-[16px]',
    'lg:tracking-[-0.3px] lg:text-[14px] lg:leading-[16px]'
  ],
  labelMediumMediumDense: [
    'font-nista-grotesk tracking-[-0.3px] text-[14px] leading-[16px] font-medium',
    'md:tracking-[-0.3px] md:text-[14px] md:leading-[16px]',
    'lg:tracking-[-0.3px] lg:text-[14px] lg:leading-[16px]'
  ],
  labelSmallRegular: [
    'font-nista-grotesk tracking-[-0.2px] text-[12px] leading-[16px] font-normal',
    'md:tracking-[-0.2px] md:text-[12px] md:leading-[16px]',
    'lg:tracking-[-0.2px] lg:text-[12px] lg:leading-[16px]'
  ],
  labelSmallMedium: [
    'font-nista-grotesk tracking-[-0.2px] text-[12px] leading-[16px] font-medium',
    'md:tracking-[-0.2px] md:text-[12px] md:leading-[16px]',
    'lg:tracking-[-0.2px] lg:text-[12px] lg:leading-[16px]'
  ],
  labelSmallNeg1Regular: [
    'font-nista-grotesk tracking-[-0.1px] text-[12px] leading-[16px] font-normal',
    'md:tracking-[-0.1px] md:text-[12px] md:leading-[16px]',
    'lg:tracking-[-0.1px] lg:text-[12px] lg:leading-[16px]'
  ],
  labelXtraSmallRegular: [
    'font-nista-grotesk tracking-[-0.2px] text-[11px] leading-[12px] font-normal',
    'md:tracking-[-0.2px] md:text-[11px] md:leading-[12px]',
    'lg:tracking-[-0.2px] lg:text-[11px] lg:leading-[12px]'
  ],
  labelXtraSmallMedium: [
    'font-nista-grotesk tracking-[-0.2px] text-[11px] leading-[12px] font-medium',
    'md:tracking-[-0.2px] md:text-[11px] md:leading-[12px]',
    'lg:tracking-[-0.2px] lg:text-[11px] lg:leading-[12px]'
  ],
  label2XtraSmallRegular: [
    'font-nista-grotesk tracking-[-0.2px] text-[10px] leading-[12px] font-normal',
    'md:tracking-[-0.2px] md:text-[10px] md:leading-[12px]',
    'lg:tracking-[-0.2px] lg:text-[10px] lg:leading-[12px]'
  ],
  label2XtraSmallMedium: [
    'font-nista-grotesk tracking-[-0.2px] text-[10px] leading-[12px] font-medium',
    'md:tracking-[-0.2px] md:text-[10px] md:leading-[12px]',
    'lg:tracking-[-0.2px] lg:text-[10px] lg:leading-[12px]'
  ],
  // Captions
  captionRegular: [
    'font-nista-grotesk tracking-[-0.2px] text-[12px] leading-[16px] font-normal',
    'md:tracking-[-0.2px] md:text-[12px] md:leading-[16px]',
    'lg:tracking-[-0.2px] lg:text-[12px] lg:leading-[16px]'
  ],
  captionMedium: [
    'font-nista-grotesk tracking-[-0.2px] text-[12px] leading-[16px] font-medium',
    'md:tracking-[-0.2px] md:text-[12px] md:leading-[16px]',
    'lg:tracking-[-0.2px] lg:text-[12px] lg:leading-[16px]'
  ],
  // Tooltips
  tooltipRegular: [
    'font-nista-grotesk tracking-[-0.2px] text-[10px] leading-[12px] font-normal',
    'md:tracking-[-0.2px] md:text-[10px] md:leading-[12px]',
    'lg:tracking-[-0.2px] lg:text-[10px] lg:leading-[12px]'
  ],
  tooltipMedium: [
    'font-nista-grotesk tracking-[-0.2px] text-[10px] leading-[12px] font-medium',
    'md:tracking-[-0.2px] md:text-[10px] md:leading-[12px]',
    'lg:tracking-[-0.2px] lg:text-[10px] lg:leading-[12px]'
  ],
  // Microtext
  microTextRegular: [
    'font-nista-grotesk tracking-[-0.2px] text-[10px] leading-[12px] font-normal',
    'md:tracking-[-0.2px] md:text-[10px] md:leading-[12px]',
    'lg:tracking-[-0.2px] lg:text-[10px] lg:leading-[12px]'
  ],
  microTextMedium: [
    'font-nista-grotesk tracking-[-0.2px] text-[10px] leading-[12px] font-medium',
    'md:tracking-[-0.2px] md:text-[10px] md:leading-[12px]',
    'lg:tracking-[-0.2px] lg:text-[10px] lg:leading-[12px]'
  ]
};

export const legacyVariantElements = {
  displayAndHeadlineXtraLarge: 'h1',
  displayAndHeadlineLarge: 'h1',
  displayAndHeadlineMedium: 'h1',
  displayAndHeadlineSmall: 'h2',
  displayAndHeadlineXtraSmall: 'h2',
  displayAndHeadline2XtraSmallMedium: 'h2',
  sectionHeaderMedium: 'h2',
  subsectionHeaderMedium: 'h3',
  subsectionHeaderRegular: 'h3',
  subsectionHeaderDense: 'h3',
  subsectionHeaderSmallMedium: 'h3',
  subheaderLargeMedium: 'h4',
  subheaderMediumMedium: 'h4',
  subheaderSmallMedium: 'h4',
  bodyLargeRegular: 'p',
  bodyLargeMedium: 'p',
  bodyMediumBaseRegular: 'p',
  bodyMediumBaseMedium: 'p',
  bodySmallRegular: 'p',
  bodySmallMedium: 'p',
  bodySmallMediumTabular: 'p',
  bodyExtraSmallRegular: 'p',
  bodyExtraSmallMedium: 'p',
  introLeadLargeRegular: 'p',
  introLeadMediumRegular: 'p',
  introLeadSmallRegular: 'p',
  calloutLargeMedium: 'p',
  calloutMediumMedium: 'p',
  calloutSmallMedium: 'p',
  calloutExtraSmallMedium: 'p',
  callout2XtraSmallMedium: 'p',
  callout3XtraSmallMedium: 'p',
  overlineLargeRegular: 'p',
  overlineLargeDenseRegular: 'p',
  overlineMediumRegular: 'p',
  overlineSmallRegular: 'p',
  labelLargeRegular: 'p',
  labelLargeMedium: 'p',
  labelMediumRegular: 'p',
  labelMediumMedium: 'p',
  labelMediumRegularDense: 'p',
  labelMediumMediumDense: 'p',
  labelSmallRegular: 'p',
  labelSmallMedium: 'p',
  labelSmallNeg1Regular: 'p',
  labelXtraSmallRegular: 'p',
  labelXtraSmallMedium: 'p',
  label2XtraSmallRegular: 'p',
  label2XtraSmallMedium: 'p',
  captionRegular: 'span',
  captionMedium: 'span',
  tooltipRegular: 'span',
  tooltipMedium: 'span',
  microTextRegular: 'span',
  microTextMedium: 'span'
};
